import { GetterTree } from 'vuex';
import ILocalState from './stateInterface';
import Jsona from 'jsona';
import { ProductReport } from '@/interfaces/ProductReport';

const dataFormatter = new Jsona();

const getters: GetterTree<ILocalState, {}> = {
    productCodeSystemList(state) {
        if (!state.productCodeSystemList) {
            return [];
        }
        return dataFormatter.deserialize(state.productCodeSystemList);
    },
    productSearchResults(state) {
        if (!state.productSearchResults) {
            return [];
        }
        return dataFormatter.deserialize(
            state.productSearchResults,
        ) as ProductReport[];
    },
    filteredSearchResults(state) {
        return state.filteredSearchResults;
    },
    singleFolder(state) {
        return state.singleFolder;
    },
    filterOptions(state) {
        return state.filterOptions;
    },
    searchKeywords(state) {
        return state.searchKeywords;
    },
    expandViaCpcs(state) {
        return state.expandViaCpcs;
    },
    searchCpcs(state) {
        return state.searchCpcs;
    },
    savedSearches(state) {
        if (!state.savedSearches) {
            return [];
        }
        return dataFormatter.deserialize(state.savedSearches);
    },
    filterData(state) {
        return state.filterData;
    },
    totalResults(state) {
        return state.totalResults;
    },
    technologyTotalItems(state) {
        if (!state.technologyTotalItems) {
            return '0';
        }
        return state.technologyTotalItems;
    },
    softwareTotalItems(state) {
        if (!state.softwareTotalItems) {
            return '0';
        }
        return state.softwareTotalItems;
    },
    goodwillTotalItems(state) {
        if (!state.goodwillTotalItems) {
            return '0';
        }
        return state.goodwillTotalItems;
    },
    trademarkTotalItems(state) {
        if (!state.trademarkTotalItems) {
            return '0';
        }
        return state.trademarkTotalItems;
    },
    customerTotalItems(state) {
        if (!state.customerTotalItems) {
            return '0';
        }
        return state.customerTotalItems;
    },
};

export default getters;
